export const SET_COLLECTION = 'data/SET_COLLECTION';
